document.addEventListener("DOMContentLoaded", function () {
    const popupContainer = document.getElementById("popup-container");
    const popupTrigger = document.getElementById("popup-trigger");
    const popupClose = document.getElementById("popup-close");
    const tabButtons = document.querySelectorAll(".tab-button");
    const tabContents = document.querySelectorAll(".tab-content");

    // Open Popup
    popupTrigger.addEventListener("click", function () {
      popupContainer.style.display = "flex";
    });

    // Close Popup
    popupClose.addEventListener("click", function () {
      popupContainer.style.display = "none";
    });

    // Tab Switching
    tabButtons.forEach(button => {
      button.addEventListener("click", function () {
        const targetTab = this.getAttribute("data-tab");

        tabButtons.forEach(btn => btn.classList.remove("active"));
        this.classList.add("active");

        tabContents.forEach(content => {
          content.id === targetTab + "-content"
            ? content.style.display = "block"
            : content.style.display = "none";
        });
      });
    });
});


setTimeout(function () {
  // Function to check if the device is desktop
  function isDesktop() {
    return window.innerWidth >= 1024; // Adjust the breakpoint as needed
  }

  if (isDesktop()) {
    var productSidebar = new StickySidebar('#leftDiv', {
      containerSelector: '.product__outer',
      innerWrapperSelector: '.product__media-list-wrapper',
      topSpacing: 10,
      bottomSpacing: 10,
    });

    // Recalculate StickySidebar when accordion toggles
    document.querySelectorAll('.product-about__accordion-item').forEach(toggle => {
      toggle.addEventListener('click', () => {
        setTimeout(() => {
          productSidebar.updateSticky();
        }, 500); // Delay slightly to allow accordion animation
      });
    });

    // Update StickySidebar on window resize
    window.addEventListener('resize', () => {
      productSidebar.updateSticky();
    });

    // Update StickySidebar when images are loaded
    document.querySelectorAll('img').forEach(img => {
      img.addEventListener('load', () => {
        productSidebar.updateSticky();
      });
    });
  }
}, 500);



